<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <h2>
      {{ labelService.getLabel(title) }}
    </h2>
    <textarea [(ngModel)]="noteText"></textarea>
    <div class="panel-buttons">
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('cancel')"
        (click)="onClose()"
      ></app-button>
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('confirm')"
        (click)="onConfirm()"
        [disabled]="isBtnClicked ? 'disabled-gray' : 'not-disabled'"
      ></app-button>
    </div>
  </div>
</div>
